<template>
  <div>
    <el-select
      key="classA"
      :disabled="disabled || type=== '编辑'"
      v-model="formData.classA"
      @change="(code)=>classChange('classBs', classAs.find(el=>el.code === code))"
    >
      <el-option v-for="item in classAs" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-select
      key="classB"
      class="select"
      :disabled="disabled"
      v-if="classBs.length !== 0"
      v-model="formData.classB"
      @change="(code) => classChange('classCs', classBs.find(el=>el.code === code))"
    >
      <el-option v-for="item in classBs" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-select
      key="classC"
      class="typeThree"
      multiple
      :disabled="disabled"
      v-if="type!=='list' && classCs.length !== 0"
      v-model="formData.classC"
      @change="(...args) => classChange('setC', ...args)"
    >
      <el-option v-for="item in classCs" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "store-types",
  props: {
    classA: Number | String,
    classC: Number | String,
    classC: Array,
    classCNeed: Boolean,
    text: Array,
    type: String,
    disabled: {
      type: Boolean,
      default: false
    },
    isShowAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        classA: "",
        classB: "",
        classC: []
      },
      classAs: [],
      classBs: [],
      classCs: []
    };
  },
  computed: {
    ...mapState(["systemConfig"]),
    classAName() {
      if (this.formData.classB === "") {
        return "";
      }
      return this.classAs.find(item => item.code === this.formData.classA).name;
    },
    classBName() {
      if (this.formData.classB === "") {
        return "";
      }
      return this.classBs.find(item => item.code === this.formData.classB).name;
    },
    classCName() {
      if (this.formData.classC.length === 0) return [];
      return this.formData.classC.map(
        code => this.classCs.find(item => item.code === code).name
      );
    }
  },
  watch: {
    formData: {
      deep: true,
      handler: function(val) {
        this.$emit("update:classA", val.classA);
        this.$emit("update:classAName", this.classAName);
        this.$emit("update:classB", val.classB);
        this.$emit("update:classBName", this.classBName);
        this.$emit("update:classC", val.classC);
        this.$emit(
          "update:classCNeed",
          val.classB && this.classCs.length ? true : false
        );
        this.$emit("update:classCName", this.classCName);
      }
    }
  },
  mounted() {
    this.classAs = this.systemConfig["managementType"];
    if (this.text) {
      this.$watch(
        "text",
        val => {
          if (val.length > 0) {
            this.initText();
          }
        },
        { immediate: true }
      );
    }
  },
  methods: {
    initText() {
      if (this.text.length !== 0) {
        const [codeA, codeB, classC = []] = this.text;
        const classA = this.classAs.find(el => el.code === codeA) || "";
        const classB = classA ? classA.items.find(el => el.code === codeB) : "";
        const classBs = classA ? classA.items : [];
        const classCs = classB ? classB.items : [];

        Object.assign(this, {
          formData: {
            classA: codeA || "",
            classB: codeB || "",
            classC: classC
          },
          classBs,
          classCs
        });
      }
    },
    classChange(type, item) {
      if (type === "setC") {
        if (item.length >= 4) {
          this.formData.classC.pop();
          this.$message({
            type: "warning",
            message: "门店类型三级不能超过三个选项"
          });
        }
        return;
      }
      switch (type) {
        case "classBs":
          Object.assign(this.formData, { classC: [], classB: "" });
          break;
        case "classCs":
          Object.assign(this.formData, { classC: [] });
          break;
      }

      this[type] = item.items;
    },
    reset() {
      this.formData.classA = "";
      this.formData.classB = "";
      this.classBs = [];
      this.classCs = [];
      this.formData.classC = [];
    }
  }
};
</script>
<style>
.select {
  margin-left: 9px;
}
.typeThree {
  margin-left: 9px;
  width: 300px;
}
.typeThree > .el-input {
  width: 300px;
}
.typeThree > .el-select__tags {
  width: 300px !important;
}
</style>